<template>
  <p class="form-group" :class="{'has-error': hasError}" @keydown="handleKeydown">
    <slot name="label">
      <label class="form-label" v-if="label" :for="field" v-text="label"></label>
    </slot>
    <slot></slot>
    <small v-if="hasError" v-text="error"></small>
  </p>
</template>

<script>
export default {
  props: {
    field: {
      type: String,
      default: '',
    },

    label: {
      type: String,
      default: null,
    },
  },

  computed: {
    error() {
      if (!this.$parent.form) {
        return null;
      }
      return this.$parent.form.getError(this.field);
    },

    hasError() {
      if (!this.$parent.form) {
        return false;
      }
      return this.$parent.form.hasError(this.field);
    },
  },

  methods: {
    handleKeydown() {
      if (!this.$parent.form) {
        return;
      }
      this.$parent.form.errors.clear(this.field);
    },
  },
};
</script>